import { Component, OnInit } from '@angular/core';
import { AlarmsService } from '../../_services/alarms.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-network-alarms',
  templateUrl: './network-alarms.component.html',
  styleUrls: ['./network-alarms.component.scss']
})
export class NetworkAlarmsComponent implements OnInit {
  constructor(private as: AlarmsService) {}

  groupedAlarms: { date: string; alarms: any[] }[] = [];
  groupedAlarms$: BehaviorSubject<any> = new BehaviorSubject([]);
  loading = false;
  searchQuery = '';

  get filteredGroupedAlarms(): { date: string; alarms: any[] }[] {
    if (!this.searchQuery.trim()) return this.groupedAlarms;
    const q = this.searchQuery.toLowerCase();
    return this.groupedAlarms
      .map((group) => ({
        ...group,
        alarms: group.alarms.filter(
          (alarm: any) =>
            alarm.circuit_no?.toLowerCase().includes(q) ||
            alarm.cause?.toLowerCase().includes(q) ||
            alarm.alarm_type?.toLowerCase().includes(q)
        )
      }))
      .filter((group) => group.alarms.length > 0);
  }

  ngOnInit(): void {
    this.loadAlarms();
  }

  loadAlarms(): void {
    this.loading = true;
    this.as.getAlarms().subscribe({
      next: (res) => {
        // The alarm store also keeps cleared alarms and info events (for the
        // Operations "All" view); this panel shows what is open now.
        this.groupedAlarms = (res || [])
          .map((group: any) => ({
            ...group,
            alarms: (group.alarms || []).filter((a: any) => !a.cleared_at && a.alarm_type !== 'info')
          }))
          .filter((group: any) => group.alarms.length > 0);
        this.groupedAlarms$.next(this.groupedAlarms);
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }
}
